import { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";

import "react-datepicker/dist/react-datepicker.css";

import TextField from "../text-field/TextField";

export interface DateRangeValue {
  startDate: Date | null;
  endDate: Date | null;
}

interface Props {
  label?: string;
  required?: boolean;
  error?: string;
  startDate: Date | null;
  endDate: Date | null;
  minDate?: Date;
  maxDate?: Date;
  onChange: (dates: [Date | null, Date | null]) => void;
}

const DATE_FORMAT = "dd-MM-yyyy";

export default function DateRangePicker({
  label,
  required,
  error,
  startDate,
  endDate,
  minDate,
  maxDate,
  onChange,
}: Props) {
  const pickerRef = useRef<DatePicker>(null);

  const [value, setValue] = useState("");

  const [tempStartDate, setTempStartDate] = useState<Date | null>(startDate);
  const [tempEndDate, setTempEndDate] = useState<Date | null>(endDate);

  useEffect(() => {
    setTempStartDate(startDate);
    setTempEndDate(endDate);
  }, [startDate, endDate]);

  useEffect(() => {
    if (startDate && endDate) {
      setValue(
        `${format(startDate, DATE_FORMAT)} - ${format(endDate, DATE_FORMAT)}`,
      );
    } else if (startDate) {
      setValue(format(startDate, DATE_FORMAT));
    } else {
      setValue("");
    }
  }, [startDate, endDate]);

  return (
    <div className="flex flex-col">
      {label && (
        <label className="mb-2 block text-sm font-medium leading-4 text-inputLabel">
          {label} {required && <span className="text-error">*</span>}
        </label>
      )}
      <DatePicker
        ref={pickerRef}
        selected={tempStartDate}
        startDate={tempStartDate}
        endDate={tempEndDate}
        selectsRange
        shouldCloseOnSelect={false}
        dateFormat={DATE_FORMAT}
        customInput={
          <TextField
            value={value}
            readOnly
            inputMode="none"
            onKeyDown={(event) => event.preventDefault()}
            onPaste={(event) => event.preventDefault()}
            onFocus={(event) => event.currentTarget.blur()}
            className="w-full"
            placeholder={DATE_FORMAT}
            error={error}
            icon={<i className="fa-regular fa-calendar text-secondary/60"></i>}
          />
        }
        minDate={minDate}
        maxDate={maxDate}
        onChange={(dates) => {
          const [start, end] = dates;

          setTempStartDate(start);
          setTempEndDate(end);

          if (start && end) {
            setValue(
              `${format(start, DATE_FORMAT)} - ${format(end, DATE_FORMAT)}`,
            );
          } else if (start) {
            setValue(format(start, DATE_FORMAT));
          } else {
            setValue("");
          }
        }}
      >
        <div className="flex items-center justify-end gap-2 border-t pt-2 px-0.5">
          <button
            type="button"
            className="rounded border px-3 py-1.5 text-sm"
            onClick={() => {
              setTempStartDate(null);
              setTempEndDate(null);

              // if (startDate && endDate) {
              //   setValue(
              //     `${format(startDate, DATE_FORMAT)} - ${format(
              //       endDate,
              //       DATE_FORMAT,
              //     )}`,
              //   );
              // } else if (startDate) {
              //   setValue(format(startDate, DATE_FORMAT));
              // } else {
              setValue("");
              // }

              pickerRef.current?.setOpen(false);
            }}
          >
            Clear
          </button>

          <button
            type="button"
            className="rounded bg-primary px-3 py-1.5 text-sm text-white"
            onClick={() => {
              onChange([tempStartDate, tempEndDate]);
              pickerRef.current?.setOpen(false);
            }}
          >
            Apply
          </button>
        </div>
      </DatePicker>
    </div>
  );
}
